<template>
  <div class="card" :id="idGroup + 'cardS' + indx">
    <div class="card-header" :id="idGroup + 'heading' + indx">
      <h5 class="mb-0">
        <button
          class="btn btn-link"
          data-toggle="collapse"
          :data-target="'#' + idGroup + 'collapseS' + indx"
          aria-expanded="true"
          :aria-controls="idGroup + 'collapseS' + indx"
        >
          Element s{{ indx }}
          <button :data-item="'s' + indx" type="button" class="btn btn-danger float-right" @click="removeItem">
            <font-awesome-icon :icon="['fas', 'minus-circle']"></font-awesome-icon>
          </button>
        </button>
      </h5>
    </div>
    <div
      :id="idGroup + 'collapseS' + indx"
      class="collapse"
      :aria-labelledby="idGroup + 'heading' + indx"
      :data-parent="'#' + idGroup + '-accordionItems'"
    >
      <div class="card-body">NOWY ELEMENT</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap';
import 'bootstrap-colorpicker';
import createjs from 'createjs-collection';

import { BaseEngine } from '../js/baseEngine.js';

export default {
  name: 'mp-item-cjs',
  components: {},
  props: {
    idGroup: {
      type: String,
      default: function () {
        return null;
      },
    },
    item: {
      type: Object,
      default: function () {
        return new BaseEngine();
      },
    },
    stage: {
      type: Object,
      default: function () {},
    },
  },
  data: function () {
    return {
      indx: -1,
      loadImgBgr: false,
    };
  },
  mounted() {
    this.indx = this.item.id.match(/\d+$/).join('');
    //this.init();
  },

  methods: {
    init() {
      let self = this;

      $(document).on('change', '#cardGr' + this.indx + ' input', function () {
        if ($(this).hasClass('grBgrColor')) {
          self.group.background.color = $(this).val();
        }

        if (self.group.positions.autoFit == true) {
          self.group.positions.pos.width = null;
          self.group.positions.pos.height = null;
        }

        self.$emit('changeConfig', self.group);
      });

      $('.itemColor').colorpicker({ format: 'rgba', color: this.group.background.color });
    },
    removeItem(e) {
      console.log('REMOVE ITEM');
      //this.$emit('changeConfig', { delete: true, idGroup: this.group.idGroup });
    },
    checkBackground(e) {
      if ($(e.target).prop('checked')) {
        this.group.background.color = 'transparent';
        $('#gr' + this.indx + '-colorBgr').val('');
      } else {
        this.group.background.color = 'rgba(255,255,255,0)';
        $('#gr' + this.indx + '-colorBgr').val(this.group.background.color);
      }

      $('#gr' + this.indx + '-colorBgr').prop('disabled', $(e.target).prop('checked'));
    },
    updateGroupCJS(e) {
      this.stage.groups[this.group.idGroup].x = this.group.positions.pos.x;
      this.stage.groups[this.group.idGroup].y = this.group.positions.pos.y;
      this.stage.groups[this.group.idGroup].pos.x = this.stage.groups[this.group.idGroup].posStart.x;
      this.stage.groups[this.group.idGroup].pos.y = this.stage.groups[this.group.idGroup].posStart.y;
    },
    loadBgrGroup(e) {
      if ($('#gr' + this.indx + '-imgBgr').val().length == 0) {
        return;
      }
      let reader = new FileReader(),
        self = this;
      reader.onload = function () {
        let preview = document.getElementById('gr' + self.indx + '-prevImgBgr');
        preview.src = reader.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    loadBgrGroupCJS(e) {
      if (!$('#gr' + this.indx + '-imgBgr').val()) {
        return;
      }
      if (typeof this.group.background.image == 'undefined' || this.group.background.image == null) {
        this.group.background.image = {
          pos: { x: 0, y: 0, width: this.group.positions.pos.width, height: this.group.positions.pos.height },
        };
      }

      this.group.background.image.src =
        'dirPath + /img/' +
        $('#gr' + this.indx + '-imgBgr')
          .val()
          .split('\\')
          .pop();

      this.stage.addImageBgr(
        document.getElementById('gr' + this.indx + '-prevImgBgr'),
        this.stage.groups[this.group.idGroup].container,
        this.group.background.image
      );

      this.loadImgBgr = true;
    },
    removeBgrGroupCJS(e) {
      if (this.loadImgBgr != true) return;
      this.loadImgBgr = false;
      document.getElementById('gr' + this.indx + '-prevImgBgr').removeAttribute('src');
      delete this.group.background.image;
      this.stage.removeImageBgr(this.stage.groups[this.group.idGroup].container);
      $('#gr' + this.indx + '-imgBgr').val('');
      let label = $('#gr' + this.indx + '-imgBgr')
        .closest('div')
        .find('label');

      $(label).html($(label).data('label'));
    },
    updateImage(e) {
      // group.background.image.pos.y
      if (this.group.background.image.pos.x + this.group.background.image.pos.width > this.group.positions.pos.width) {
        this.group.positions.pos.width = this.group.background.image.pos.x + this.group.background.image.pos.width;
      }
      if (
        this.group.background.image.pos.y + this.group.background.image.pos.height >
        this.group.positions.pos.height
      ) {
        this.group.positions.pos.height = this.group.background.image.pos.y + this.group.background.image.pos.height;
      }
      this.stage.updateImageBgr(this.stage.groups[this.group.idGroup].container, this.group.background.image.pos);

      this.$emit('changeConfig', this.group);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {},
};
</script>
<style lang="sass"></style>
<style lang="sass" scoped>
.mb-0, .mb-0 > button:first-child
    width: 100%

.tab-pane
  padding-top: 20px

.prevImgBgr
  width: 100px
  height: 100px
  margin-top: 10px
</style>
